import { Popover } from 'bootstrap';

export default function init(): void {
	const wipElements = document.getElementsByClassName('wip');

	for (const wipEl of wipElements) {
		const el = wipEl as HTMLElement;

		const defaultNotes = `This doesn't work yet!${
			el.dataset.jiraIssue
				? ' It will be implemented in ' + el.dataset.jiraIssue
				: ' Has a JIRA issue been created for it?'
		}`;

		const jiraIssueLinkHtml = el.dataset.jiraIssue
			? `<div><a href="https://jira.mainstream-tech.com/browse/${el.dataset.jiraIssue}" target="_blank">${el.dataset.jiraIssue}</a></div>`
			: '';

		const notesHtml = `<div class="mt-2">${el.dataset.notes ?? defaultNotes}</div>`;

		const _ = new Popover(wipEl, {
			title: 'Work in progress...',
			html: true,
			content: `${jiraIssueLinkHtml}${notesHtml}`,
			trigger: 'click',
			sanitize: false,
		});
	}
}
